/**
 * Mirror of the CRM engine's acceptance shape — `EMAIL_RE` in viq-backend
 * `shared/src/normalize.ts` is the source of truth (local@domain.tld, exactly
 * one @, TLD >= 2). Must stay in lockstep: anything looser here saves a value
 * `normalizeEmail` then rejects, and the row bounces straight back to Clean.
 *
 * Clean's email check, in the legacy Clean view and on the unified grid's
 * Clean tab alike. Stricter than the lead-edit rule (`PersonEditSchema`'s
 * `^\S+@\S+\.\S+$`), which the Leads tab keeps.
 */
export const CRM_EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Whether `value` (already trimmed) is an address the CRM engine accepts. */
export function isCrmEmailShape(value: string): boolean {
  return CRM_EMAIL_SHAPE.test(value);
}
